export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const GET_USER_INTG_REQUEST = 'GET_USER_INTG_REQUEST';
export const GET_USER_INTG_SUCCESS = 'GET_USER_INTG_SUCCESS';
export const GET_USER_INTG_FAILURE = 'GET_USER_INTG_FAILURE';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
